/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { CircularProgressbar } from 'react-circular-progressbar'

import { Accordion, AccordionItem } from '../components/Accordion'
import UiSelect from '../../../components/UI/UISelect'
import UIButton from '../../../components/UI/UIButton'
import UITextInput from '../../../components/UI/UITextInput'
// import UIDocumentPicker from '../../../components/UI/UIDocumentPicker'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import UIStaightlineProressBar from '../../../components/UI/UIStaightlineProressBar'
import {
  UploadResponse,
  UserTraningRecordsData,
  trainingRecordCategories,
  trainingRecordCategoriesResponse,
  trainingRecordCategoriesResponseObj,
  trainingRecords,
  trainingResponse,
} from '../../../utils/types'
import {
  createProfileTrainingRecord,
  getProfileTrainingRecord,
  getTrainingRecordCategories,
  updateProfileTrainingRecord,
} from '../../../api/candidate/myscrApis'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import UIDatePickerv from '../../../components/UI/UIDatePickerv'
import UIDatePicker from '../../../components/UI/UIDatePicker'
import UIDocumentPicker from '../../../components/UI/UIDocumentPicker'
import { fileUpload } from '../../../api/apiService'
import {
  calculateNonNullPercentage,
  getTrainingScoreFields,
  aggregateTrainingScore,
} from '../../../utils/utils'
import Modal from '../../../components/UI/UIModal'
import { Icon } from '../../../components/Icon'
// import UIDatePickerv from '../../../components/UI/UIDatePickerv'

// const traningRecords: trainingRecords[] = [
//   {
//     certificateNumber: 'number123',
//     date: '2023-01-01T00:00:00Z',
//     reviewDate: '2023-01-01T00:00:00Z',
//     verifiedBy: 'IT',
//     verificationDate: '2023-01-01T00:00:00Z',
//     riskAssessmentStatus: 'YES',
//     duration: '12 Months',
//     certificate: 'Certificate',
//     id: '',
//     userId: 'e0b59845-f4ab-40ed-8d6c-95385203e371',
//     trainingRecordCategoryId: 'safeguarding',
//   },
//   {
//     certificateNumber: 'number123',
//     date: '2023-01-01T00:00:00Z',
//     reviewDate: '2023-01-01T00:00:00Z',
//     verifiedBy: 'IT',
//     verificationDate: '2023-01-01T00:00:00Z',
//     riskAssessmentStatus: 'YES',
//     duration: '12 Months',
//     certificate: 'Certificate',
//     id: '',
//     userId: 'e0b59845-f4ab-40ed-8d6c-95385203e371',
//     trainingRecordCategoryId: 'prevent_duty',
//   },
//   {
//     certificateNumber: 'number123',
//     date: '2023-01-01T00:00:00Z',
//     reviewDate: '2023-01-01T00:00:00Z',
//     verifiedBy: 'IT',
//     verificationDate: '2023-01-01T00:00:00Z',
//     riskAssessmentStatus: 'YES',
//     duration: '12 Months',
//     certificate: 'Certificate',
//     id: '',
//     userId: 'e0b59845-f4ab-40ed-8d6c-95385203e371',
//     trainingRecordCategoryId: 'edi',
//   },
//   {
//     certificateNumber: 'number123',
//     date: '2023-01-01T00:00:00Z',
//     reviewDate: '2023-01-01T00:00:00Z',
//     verifiedBy: 'IT',
//     verificationDate: '2023-01-01T00:00:00Z',
//     riskAssessmentStatus: 'YES',
//     duration: '12 Months',
//     certificate: 'Certificate',
//     id: '',
//     userId: 'e0b59845-f4ab-40ed-8d6c-95385203e371',
//     trainingRecordCategoryId: 'wellbeing',
//   },
//   {
//     certificateNumber: 'number123',
//     date: '2023-01-01T00:00:00Z',
//     reviewDate: '2023-01-01T00:00:00Z',
//     verifiedBy: 'IT',
//     verificationDate: '2023-01-01T00:00:00Z',
//     riskAssessmentStatus: 'YES',
//     duration: '12 Months',
//     certificate: 'Certificate',
//     id: '',
//     userId: 'e0b59845-f4ab-40ed-8d6c-95385203e371',
//     trainingRecordCategoryId: 'health_safety',
//   },
//   {
//     certificateNumber: 'number123',
//     date: '2023-01-01T00:00:00Z',
//     reviewDate: '2023-01-01T00:00:00Z',
//     verifiedBy: 'IT',
//     verificationDate: '2023-01-01T00:00:00Z',
//     riskAssessmentStatus: 'YES',
//     duration: '12 Months',
//     certificate: 'Certificate',
//     id: '',
//     userId: 'e0b59845-f4ab-40ed-8d6c-95385203e371',
//     trainingRecordCategoryId: 'first_aid',
//   },
// ]

export interface trainingRecordsData {
  certificateNumber?: string
  date?: string
  reviewDate?: string
  verifiedBy?: string
  verifiedByName?: string
  verificationDate?: string
  riskAssessmentStatus?: string
  duration?: string
  certificate?: string
  id?: string
  userId?: string
  trainingRecordCategoryId?: string
  createdAt?: string
  schoolId?: string
  title?: string
  updatedAt?: string
  referenceUrl?: string
  isRejected?: boolean
  riskDocument?: string
}

export interface createRecordFormDataInterface {
  title?: string
  certificateNumber?: string
  date?: string
  reviewDate?: string
  verifiedBy?: string
  verificationDate?: string
  riskAssessmentStatus?: string
  duration?: string
  certificate?: string
  trainingRecordCategoryId?: string
}

export interface updateRecordFormDataInterface {
  title?: string
  certificateNumber?: string
  date?: string
  reviewDate?: string
  verifiedBy?: string
  verificationDate?: string
  riskAssessmentStatus?: string
  duration?: string
  certificate?: string
  riskDocument?: string
  trainingRecordCategoryId?: string
  id?: string
  userId?: string
  schoolId?: string
  createdAt?: string
  updatedAt?: string
}
type TrainingRecord = {
  id?: string
  userId: string
  trainingRecordCategoryId: string
  schoolId?: string
  certificateNumber: string | null
  date: string | null
  reviewDate: string | null
  verifiedBy: string | null
  verificationDate: string | null
  riskAssessmentStatus: string | null
  duration: string | null
  certificate: string | null
  riskDocument: string | null
}
type AnyObject = { [key: string]: any }
type AnyArray = any[]

const TrainingRecords = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const [alertActive, setAlertActive] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const [trainingRecordsData, setTrainingRecordsData] =
    useState<trainingRecordsData[]>()
  const [createRecordFormData, setCreateRecordFormData] = useState<
    createRecordFormDataInterface[]
  >([])
  const [updateRecordFormData, setUpdateRecordFormData] = useState<
    updateRecordFormDataInterface[]
  >([])

  function convertNullsToUndefined(
    obj: AnyObject | AnyArray,
    columnsToRemove?: string[]
  ): AnyObject | AnyArray | undefined {
    if (Array.isArray(obj)) {
      return obj.map((item) => convertNullsToUndefined(item, columnsToRemove))
    } else if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
        if (!columnsToRemove?.includes(key)) {
          // Check if the key is not in the columns to remove
          acc[key] = convertNullsToUndefined(obj[key], columnsToRemove)
        }
        return acc
      }, {})
    } else {
      return obj === null ? undefined : obj
    }
  }

  const fetchTrainingRecordCategories =
    async (): Promise<trainingRecordCategoriesResponseObj> => {
      const response =
        (await getTrainingRecordCategories()) as trainingRecordCategoriesResponse
      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const fetchTrainingRecord = async (): Promise<trainingRecords[]> => {
    const response = (await getProfileTrainingRecord()) as trainingResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const {
    data: trainingRecords,
    isLoading: isLoadingRecords,
    isError: isErrorRecords,
    refetch: refetchRecords,
  } = useQuery('userTraining', fetchTrainingRecord)
  const {
    data: trainingCategories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
    refetch: refetchCategories,
  } = useQuery('trainingRecordCategories', fetchTrainingRecordCategories)

  const convertToUndefined = (value: any) => (value ? value : undefined)

  useEffect(() => {
    if (trainingRecords !== undefined) {
      const mergedArray = trainingCategories?.data?.map((category) => {
        const matchingRecords =
          trainingRecords?.filter(
            (record) => record.trainingRecordCategoryId === category.id
          ) || []
        // If no matching records are found, include only the category title
        if (matchingRecords.length === 0) {
          return {
            title: category.title,
            trainingRecordCategoryId: category.id,
            referenceUrl: category?.referenceUrl
              ? category?.referenceUrl
              : undefined,
          }
        } else {
          let obj = {}
          matchingRecords.map((record: any) => {
            const updatedRecord: any = {}
            for (const key in record) {
              // eslint-disable-next-line no-prototype-builtins
              if (record.hasOwnProperty(key)) {
                updatedRecord[key] = convertToUndefined(record[key])
              }
            }
            obj = {
              ...updatedRecord,
              title: category.title,
              referenceUrl: category?.referenceUrl,
            }
          })
          return obj
        }
      })
      if (mergedArray) setTrainingRecordsData(mergedArray)
    }
  }, [trainingRecords, trainingCategories])

  const handleChange = (
    fieldName: string,
    value: string | boolean,
    item: trainingRecordsData
  ) => {
    if (Object.keys(item)?.length > 3) {
      setTrainingRecordsData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.trainingRecordCategoryId === item.trainingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            if (index === existingItemIndex) {
              return {
                ...record,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
      setUpdateRecordFormData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.trainingRecordCategoryId === item.trainingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            const { title, ...rest } = record
            if (index === existingItemIndex) {
              return {
                ...rest,
                [fieldName]: value,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value,
            },
          ]
        }
      })
    } else {
      if (fieldName == 'certificate' || undefined) {
        setTrainingRecordsData((prev) => {
          if (!prev) {
            // If previous state is undefined, return a new array with the updated item
            return [
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
          // Check if the item exists in the previous state
          const existingItemIndex = prev.findIndex(
            (record) =>
              record.trainingRecordCategoryId === item.trainingRecordCategoryId
          )
          if (existingItemIndex !== -1) {
            // If the item exists, update the specified field name with the provided value
            return prev.map((record, index) => {
              if (index === existingItemIndex) {
                return {
                  ...record,
                  [fieldName]: value,
                }
              }
              return record
            })
          } else {
            // If the item doesn't exist, add it and update the specified field name with the provided value
            return [
              ...prev,
              {
                ...item,
                [fieldName]: value,
              },
            ]
          }
        })
      }
      setCreateRecordFormData((prev) => {
        const matchingRecords =
          prev?.filter(
            (record) =>
              record.trainingRecordCategoryId === item.trainingRecordCategoryId
          ) || []
        if (matchingRecords.length === 0) {
          const newItem = {
            ...item,
            [fieldName]: value,
          }
          return [...prev, newItem]
        } else {
          const updatedRecords =
            prev?.map((record) => {
              if (
                record.trainingRecordCategoryId ===
                item.trainingRecordCategoryId
              ) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value,
                }
              }
              return record
            }) || []

          return updatedRecords
        }
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: trainingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('certificate', response?.url, item)
      } catch (error) {
        handleChange(
          'certificate',
          item?.certificate ? item?.certificate : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    event.target.value = ''
  }
  const handleRiskFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: trainingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('riskDocument', response?.url, item)
      } catch (error) {
        handleChange(
          'riskDocument',
          item?.riskDocument ? item?.riskDocument : '',
          item
        )
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    event.target.value = ''
  }

  const handleUpdateRecords = async (): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      if (createRecordFormData?.length != 0) {
        const convertedValues = convertNullsToUndefined(createRecordFormData, [
          'title',
          'verifiedByName',
          'certificateUrl',
          'riskDocumentUrl',
          'referenceUrl',
        ])
        const bodyData = {
          // school: data?.schoolId || '',
          trainingRecords: convertedValues,
        } as UserTraningRecordsData
        const response = (await createProfileTrainingRecord(bodyData)) as {
          status?: string
          data: trainingRecords
        }
        if (response?.status == 'successful') {
          refetchCategories()
          refetchRecords()
          setCreateRecordFormData([])
          toast.success('Records Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      }
    } catch (error) {
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
    try {
      setIsUpdateLoading(true)
      if (updateRecordFormData?.length != 0) {
        const convertedValues = convertNullsToUndefined(updateRecordFormData, [
          'title',
          'verifiedByName',
          'certificateUrl',
          'riskDocumentUrl',
          'referenceUrl',
        ])
        const bodyData = {
          trainingRecords: convertedValues,
        } as UserTraningRecordsData
        const response = (await updateProfileTrainingRecord(bodyData)) as {
          status?: string
          data: trainingRecords
        }
        if (response?.status == 'successful') {
          setUpdateRecordFormData([])
          refetchCategories()
          refetchRecords()
          toast.success('Records Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      }
    } catch (error) {
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target as Node) &&
      alertActive
    ) {
      setIsOpenAlert(true)
    } else if (isOpenAlert == false) {
      setAlertActive(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [alertActive])

  // Overall scorecard = every field of every category, scored as one set.
  // Field set + scoring are shared via utils so this view matches the admin /
  // lead views exactly (see getTrainingScoreFields).
  const scorecard = aggregateTrainingScore(
    trainingCategories?.data,
    trainingRecordsData
  )

  return (
    <div
      ref={divRef}
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          // scrollbarWidth: 'none',
        }}
      >
        <UISubHeaderComponent
          mainPage="My SCR Overview"
          subPage="Training Records"
          //copy="This is where all of your training records are gathered. You can get a full overview of all the completed and outstanding details needed for your record."
          onDelete={() => {}}
          isViewMode={false}
          isCreatePolicy={false}
        />
        <div className="flex my-8 gap-2">
          {/* First column */}
          <div
            style={{
              // height: 'calc(100vh - 100px)',
              overflow: 'auto',
              scrollbarWidth: 'none',
            }}
            className="flex flex-col w-8/12 gap-4"
          >
            {trainingRecordsData?.map(
              (item: trainingRecordsData, index: number) => {
                return (
                  <Accordion key={index} defaultActiveIndex={null}>
                    <AccordionItem
                      onClick={() => console.log('Accordion')}
                      title={item?.title ? item?.title : ''}
                      isActive={false}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UITextInput
                              placeholder={'Certificate Number'}
                              label={'Certificate Number'}
                              iconName={''}
                              value={item ? item?.certificateNumber : ''}
                              onChange={(e) =>
                                handleChange(
                                  'certificateNumber',
                                  e.target.value,
                                  item
                                )
                              }
                            />
                          </div>

                          <div className="w-6/12  ">
                            <UITextInput
                              placeholder={'External Url'}
                              label={'External Url'}
                              iconName={''}
                              readOnly
                              value={item ? item?.referenceUrl : ''}
                              onChange={(e) =>
                                handleChange(
                                  'referenceUrl',
                                  e.target.value,
                                  item
                                )
                              }
                            />
                          </div>
                        </div>
                        <UIDocumentPicker
                          isRejected={item?.isRejected}
                          id={item?.title ? item?.title : 'pickerInput'}
                          handleRemoveFile={() => {
                            handleChange('certificate', '', item)
                          }}
                          label={'Certificate'}
                          initialValue={
                            item?.certificate ? item?.certificate : ''
                          }
                          onChange={(e) =>
                            handleFileChange('certificate', e, item)
                          }
                          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                          labelClassName="custom-label-class"
                        />
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Date'}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange('date', e.target.value, item)
                              }}
                              value={item?.date ? item?.date.split('T')[0] : ''}
                            />
                          </div>
                          <div className="w-6/12">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Review Date'}
                              value={
                                item?.reviewDate
                                  ? item?.reviewDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange('reviewDate', e.target.value, item)
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex w-full gap-4">
                          <div className="w-6/12  ">
                            <UITextInput
                              placeholder={'Not specified'}
                              label={'Verified by'}
                              readOnly
                              iconName={''}
                              value={item?.verifiedByName || ''}
                              onChange={(e) =>
                                handleChange('verifiedBy', e.target.value, item)
                              }
                            />
                          </div>
                          <div className="w-6/12">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Verification Date'}
                              readOnly
                              value={
                                item?.verificationDate
                                  ? item?.verificationDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange(
                                  'verificationDate',
                                  e.target.value,
                                  item
                                )
                              }}
                            />
                          </div>
                        </div>
                        <UIDocumentPicker
                          id={item?.title ? item?.title : 'pickerInput'}
                          handleRemoveFile={() => {
                            handleChange('riskDocument', '', item)
                          }}
                          label={'Risk Assesment Document'}
                          initialValue={
                            item?.riskDocument ? item?.riskDocument : ''
                          }
                          onChange={(e) =>
                            handleRiskFileChange('riskDocument', e, item)
                          }
                          accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                          labelClassName="custom-label-class"
                        />
                      </div>
                    </AccordionItem>
                  </Accordion>
                )
              }
            )}
          </div>

          {/* Second column */}
          <div className="w-4/12">
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'Scorecard'}
                isActive={true}
                AccordionItemStyle={{
                  backgroundColor: 'rgba(230, 240, 243, 1)',
                }}
                AccordiontitleStyle={
                  'text-sm text-bluishGreen flex-1 font-semibold'
                }
                AccordionItemStyleContainer={{
                  backgroundColor: 'rgba(242, 247, 249, 1)',
                }}
                icon={'IconBarChartSquare'}
              >
                <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                  <div className="w-[160px] h-[160px]">
                    <CircularProgressbar
                      strokeWidth={5}
                      value={scorecard.percentage}
                      text={`${scorecard.percentage}%`}
                      styles={{
                        root: {},
                        path: {
                          stroke: scorecard.color,
                          transition: 'stroke-dashoffset 0.5s ease 0s',
                        },
                        text: {
                          fill: '#013546',
                          fontSize: '24px',
                          fontWeight: 700,
                          lineHeight: 40,
                        },
                      }}
                    />
                  </div>
                  <div className="items-center justify-center flex">
                    <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                      {scorecard.percentage == 100
                        ? 'Well done you reached 100%'
                        : scorecard.percentage == 0
                          ? 'Make a start to improve your score'
                          : 'Great start! But there is still room for improvement'}
                    </p>
                  </div>
                  <Accordion defaultActiveIndex={0}>
                    <AccordionItem
                      onClick={() => console.log('Accordion')}
                      title={'Your score is broken down as follows:'}
                      isActive={false}
                      AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                      AccordiontitleStyle={
                        'text-xs font-semibold text-text4 leading-5 flex-1'
                      }
                      AccordionItemStyleContainer={{
                        backgroundColor: '#FFFFFF',
                      }}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        {trainingCategories?.data?.map((item, index) => (
                          <div key={index} className="  ">
                            <div className="">
                              <UIStaightlineProressBar
                                percentage={
                                  calculateNonNullPercentage(
                                    getTrainingScoreFields(trainingRecordsData?.[index])
                                  ).percentage
                                }
                                label={item?.title}
                                stroke={
                                  calculateNonNullPercentage(
                                    getTrainingScoreFields(trainingRecordsData?.[index])
                                  ).color
                                }
                                strokeWidth={1.5}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionItem>
                  </Accordion>
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
        <div className="bg-gray3 w-full h-[1px] my-3"></div>
        <div className="w-[33%] mt-6">
          <UIButton
            loading={isUpdateLoading}
            onClick={handleUpdateRecords}
            label="Update"
          />
        </div>
      </div>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenAlert}
        onClose={() => {
          setIsOpenAlert(false)
        }}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Save changes?
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Do you want to save changes before moving on?{' '}
            </p>
          </div>

          <button
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default TrainingRecords
